import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const options = {
  name: 'template-component',
};

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      padding: theme.spacing(3.875),
    },
    hints: {},
    hintsResult: {
      '& $hint': {
        '&:before': {
          content: '""',
          display: 'inline-block',
          width: 16,
          height: 16,
          borderRadius: 4,
          backgroundColor: theme.palette.error.main,
        },
        '&$done:before': {
          backgroundColor: theme.palette.success.main,
        },
      },
    },
    hint: {
      '&:before': {
        content: '""',
        display: 'inline-block',
        width: 16,
        height: 16,
        borderRadius: 4,
        backgroundColor: theme.palette.warning.main,
        marginRight: theme.spacing(0.5),
      },
      '&$done:before': {
        backgroundColor: theme.palette.primary.main,
      },
      display: 'flex',
      alignItems: 'center',
      '& span': {
        marginLeft: theme.spacing(0.5),
      },
    },
    done: {},
    left: {},
    questionBtn: {
      width: theme.spacing(4),
      minWidth: theme.spacing(4),
      height: theme.spacing(4),
      ...theme.typography.body2,
    },
    appeal: {
      color: 'inherit',
      cursor: 'auto',
      '& i': {
        fontStyle: 'normal',
        color: theme.palette.primary.main,
        cursor: 'pointer',
      },
    },
  }),
  options
);

export default useStyles;
